export default __webpack_public_path__ + "assets/images/telegram-2eb7155d7cdbd5ecf22456dc3c5b9117.svg";